import '../../styles/game/GameRules.css';
import '../../styles/game/ProvablyFair.css';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';



function ProvablyFair({ isOpen, onClose, ProvablyOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                setIsVisible(true);
            }, 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`gameRulesWrapper ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("whatIsProvably")}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'provably-modal-wrapper'}>
                            <div className={'verify-big'}>
                                <div></div>
                            </div>
                            <div className={'modal-text-center'}>
                                <span>{t("provablyFair100")}</span>
                            </div>
                            <div className={'modal-top-text'}>
                                <span>
                                    {t("aviatorDescriptionText")}
                                </span>
                            </div>
                            <div className={'text-center'}>
                                {t("howItWorks")}
                            </div>
                            <div>
                                {t("quickExplanation")}
                            </div>
                            <div className={'provably-description mt-10'}>
                                {t("quickExplanationText")}
                            </div>
                            <div className={'mt-20'}>
                                {t("moreInformation")}
                            </div>
                            <div className={'provably-description mt-10'}>
                                {t("moreInformationText")}
                            </div>
                            <div className={'provably-description mt-10'}>
                                {t("moreInformationText2")}
                            </div>

                            <div></div>
                            <div className={'pf-schema'}>
                                <div></div>
                            </div>
                            <div className={'text-center'}>
                                {t("howToChek")}
                            </div>
                            <div className={'provably-description mt-30'}>
                                <div>{t("howToChek1")}</div>
                                <div>{t("howToChek2")}</div>
                                <div>{t("howToChek3")}</div>
                                <div>{t("howToChek4")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default ProvablyFair;